/**
 * テーマ (dark / light) の解決ロジック
 *
 * Design Guide はプロトタイプ同様ダークテーマが既定。localStorage `creative-theme` に
 * 永続化し、`<html data-theme>` 属性で切り替える (index.html の初期化スクリプトと対)。
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business Design Guide のテーマ切替 (dark既定/light) の純粋ロジック。localStorage 値の解決と次テーマ算出。
 * @graph-connects none
 */

/** テーマ種別。 */
export type Theme = 'dark' | 'light';

/** localStorage のテーマ保存キー。 @graph-connects none */
export const THEME_STORAGE_KEY = 'creative-theme';

/**
 * localStorage の生値からテーマを解決する。不正値・未設定はダーク。
 * @param stored localStorage の生値
 * @returns 解決済みテーマ
 * @graph-connects none
 */
export function resolveStoredTheme(stored: string | null): Theme {
  return stored === 'light' ? 'light' : 'dark';
}

/**
 * トグル後のテーマを返す。
 * @param current 現在のテーマ
 * @returns 反転したテーマ
 * @graph-connects none
 */
export function nextTheme(current: Theme): Theme {
  return current === 'dark' ? 'light' : 'dark';
}
